/**
 * InvoiceBatch-related strings.
 */
import React from 'react';

export default {
    d_title: 'Trust Sweep',
    h_title: 'After invoicing, see how much to move from trust to operating, and track replenishment and delivery.',

    d_invoiceBatches: 'Trust Sweep',
    h_invoiceBatches: '<div><p><b>Trust Sweep</b> figures out how much you can move from trust to operating after a billing run, and tracks:</p><ul><li>Does the trust need to be replenished?</li><li>If required, <i>has</i> the trust been replenished?</li><li>Has the invoice been sent to the client, and by what method (email/mail)?</li><li>How much money can be transferred from IOLTA to operating, both for expenses and labor?</li></ul><p></p></div>',

    d_update: 'Refresh',
    h_update: 'Update the values based on a fresh pull of data, given the start and end dates above.',
    h_updateFinalized: 'Warning: Refresh will overwrite the values of this completed sweep!',

    d_startOn: 'Start On',
    h_startOn: '<div><p>Only consider invoices with a start date on or after this date. It is normal to leave this field empty, as it will search for all invoices before the end date that are not already part of a Trust Sweep.</p></div>',

    d_endOn: 'End On',
    h_endOn: '<div><p>Only consider invoices with an end date on or before this date.</p><p>Once entered, click on Refresh to retrieve invoices for this Trust Sweep</p><p><i>Note that updating dates and clicking Refresh will add/remove invoices from the Trust Sweep, but your changes will be preserved for remaining rows.</i></p></div>',

    d_transferOn: 'Transfer On',
    h_transferOn: '<div><p>Date that all transfers were completed.</p><p>Once this date is entered, the Trust Sweep is considered complete. Please ensure that all fields have been updated!</p></div>',

    d_invoiceInfo: 'Invoice Info',
    h_invoiceInfo: <div>
        <p>These are the invoices that have not been processed (the money
            has not been transferred from trust to operating in the real
            world).</p>
        <p>These fields help identify the invoice in question.</p>
    </div>,

    d_trustAccounting: 'Trust Accounting',
    h_trustAccounting: <div>
        <p>These fields summarize the state of the client's trust funds (both
            general and case trusts are included in the totals).</p>
        <p>The <b>Minimum</b> field denotes the minimum amount of funds
            required in the trust (e.g. an Evergreen retainer).</p>
        <p>The <b>Balance</b> field indicates the current balance of all trusts.
        </p>
        <p><b>Trust Payments</b> are payments made from the trust to operating.</p>
        <p>The <b>Needed</b> field indicates how much needs to be collected
            from the client to up the trust to the minimum balance. This field
            is editable, as you may decide that more funds are needed (e.g. a
            trial is coming up) or less funds are needed (e.g. end of a case).
        </p>
        <p>The <b>Replenish?</b> checkbox is automatically checked if the
            current trust balance is below the minimum trust balance. If
            replenishment is not needed, uncheck the box.</p>
        <p>The <b>Replenished?</b> checkbox indicates that the trust has been
            replenished. Check this off after you have deposited funds from
            the client into the trust.</p>
    </div>,

    d_invoiceAmounts: 'Invoice Amounts',
    h_invoiceAmounts: <div>
        <p>These fields are from the invoice and help you understand the
            current state of the client's account.</p>
        <p>The <b>Previous Balance</b> field is the amount carried over from
            the previous invoice. This is the starting balance for this invoice
            period.</p>
        <p>The <b>Added</b> field indicates how much additional work and
            expenses were earned/incurred in this invoice period.</p>
        <p>The <b>Due</b> field indicates the current amount due for the case.
        </p>
        <p>The <b>Direct Payments</b> field totals payments made from the
            client to operating during this invoice period. This does not
            include payments from the trust account, only payments made
            directly from the client (e.g. credit card or cash).</p>
    </div>,

    d_invoiceSent: 'Invoice Sent',
    h_invoiceSent: 'These fields indicate the date that the invoice was sent to the client, and the method used to send it.',

    d_directPayments: 'Direct Payments',
    h_directPayments: 'Payments made directly from the client to operating (paying a due invoice).',

    d_trustPayments: 'Trust Payments',
    h_trustPayments: 'Payments made from trust account(s).',
    d_replenished: 'Replenished?',
    h_replenished: 'Has the trust been replenished?',

    d_replenish: 'Replenish?',
    h_replenish: 'Does the trust require replenishment at this time?',

    d_previousBalance: 'Previous Balance',

    d_added: 'Added',
    h_added: 'Expenses and labor added during this invoice period',

    d_amountsToTransfer: 'Amounts to Transfer',
    h_amountsToTransfer: <div>
        <p>These are the amounts to transfer from your trust account to your
            operating account.</p>
        <p>We separate out the amounts for expenses and labor, as labor
            is taxed, but expenses are not (they are a reimbursement). You
            should have separate entries in your ledger for each so that your
            accountant can properly categorize them.</p>
    </div>,

    d_needed: 'Needed',
    h_needed: 'The amount needed to replenish the trust to the required minimum level.',
    h_notes: <div>Any notes that will help you document the transfers for this case.</div>


};